import React from "react";
import PageBannerHome from "../../images/poster-home-page.jpeg";
import HomePageMedia from "../../images/home-page-video.mp4";
import IconHt from "../../images/icon-partner-harristeeter.svg";
import IconKroger from "../../images/icon-partner-kroger.svg";
import IconDassault from "../../images/icon-partner-dassault.svg";
import IconFlexprint from "../../images/icon-partner-flexprint.svg";
import IconSalesmate from "../../images/icon-partner-salesmate.svg";
import IconBigCommerce from "../../images/icon-partner-bigcommerce.svg";
import IconTresata from "../../images/icon-partner-tresata.svg";
import IconCb from "../../images/icon-partner-cb.svg";
import ProductBanner from "../../images/page-banner-product-mobile-development.png";
import ServiceWatchBanner from "../../images/service-banner-watch.jpeg";
import ServicePhoneBanner from "../../images/service-banner-phone.png";
import ServiceDateRange from "../../images/service-banner-date-range.jpeg";
import ServiceEmployee from "../../images/service-banner-employee.jpeg";
import ServiceLoading from "../../images/service-banner-loading.jpeg";
import ServiceResearch from "../../images/service-banner-market-research.jpeg";
import ServiceMessage from "../../images/service-banner-message.jpeg";
import ServiceRatio from "../../images/service-banner-ratio.jpeg";
import ServiceRole from "../../images/service-banner-role.jpeg";
import ServiceUser from "../../images/service-banner-user.jpeg";
import ServicEarth from "../../images/banner-image-earch.gif";
import IconStrategy from "../../images/icon-service-strategy.svg";
import IconDesign from "../../images/icon-service-design.svg";
import IconEngineering from "../../images/icon-service-engineering.svg";
import IconInnovations from "../../images/icon-be-bold.svg";
import BlockquoteImg from "../../images/img-testimonial-Cabanillas.jpg";
import IconFlag from "../../icons/icon-flag.svg";
import IconTeam from "../../icons/icon-team.svg";
import IconLaunched from "../../icons/icon-launched.svg";

import ImageAWS from "../../images/aws-partner.svg";
import ImageClutch from "../../images/clutch.svg";
import ImageFast50 from "../../images/fast-50.svg";
import ImageGooglePartner from "../../images/google-partner.svg";
import ImageHackthon from "../../images/hackthon.svg";
import ImageINC from "../../images/inc-5000.svg";
import ImageISO from "../../images/iso.svg";

export const mainBannerObj = {
  classes: "",
  header: (<>Launch outstanding <br />digital products & <br />experiences</>),
  position: "",
  content: "",
  link: "form-section",
  scrollSection: "home-page-into-section",
  buttonText: "Explore Our Services",
  mediaType: "video",
  mediaSource: HomePageMedia,
  mediaClass: "",
  mediaPoster: PageBannerHome,
  bottomGap: ""
};

export const blogGridObj = {
  classes: ""
};

export const introObj = {
  content: (<> We build and transform businesses by launching market-leading digital <br /> products, platforms, and experiences that fuel their growth.</>)
};

export const homePartnerObj = {
  classes: "",
  title: "you’re in a good company",
  header: "Top global brands trust us to deliver their software products ",
  content: (<> We’ve helped companies of all sizes and shapes build advanced products, platforms and solutions that are simple, intuitive, and scalable. </>),
  partnerLogos: [
    {
      link: "#",
      image: IconHt,
      alt: "harris teeter",
      title: "Harris Teeter"
    },
    {
      link: "#",
      image: IconKroger,
      alt: "kroger",
      title: "Kroger"
    },
    {
      link: "#",
      image: IconDassault,
      alt: "dassault systemes",
      title: "Dassault Systemes"
    },
    {
      link: "#",
      image: IconTresata,
      alt: "tresata",
      title: "Tresata"
    },
    {
      link: "#",
      image: IconBigCommerce,
      alt: "bigCommerce",
      title: "BigCommerce"
    },
    {
      link: "#",
      image: IconFlexprint,
      alt: "flexprint",
      title: "Flexprint"
    },
    {
      link: "#",
      image: IconSalesmate,
      alt: "salesmate",
      title: "Salesmate"
    },
    {
      link: "#",
      image: IconCb,
      alt: "the cook & boardman group",
      title: "The Cook & Boardman Group"
    },
  ],
  companyCounterItems: [
    {
      header: <><IconFlag /></>,
      count: 12,
      content: "Years in Business",
      //content: <><h6>12</h6><i className="icon-plus"><IconGreen /></i><p>Years in Business</p></>
    }, {
      header: <><IconTeam /></>,
      count: 250,
      content: "Talented Experts",
      //content: <><h6>220</h6><i className="icon-plus"><IconGreen /></i><p>Talented Experts</p></>
    }, {
      header: <><IconLaunched /></>,
      count: 210,
      content: "Products Launched",
      //content: <><h6>140</h6><i className="icon-plus"><IconGreen /></i><p>Products Launched</p></>
    },
  ]
};

export const homeAccoladesObj = {
  classes: "",
  title: "ACCOLADES & ALLIANCES",
  accoladesLogos: [

    {
      link: "#",
      image: ImageINC,
      alt: "Inc 5000",
      title: "Inc 5000"
    },
    {
      link: "#",
      image: ImageFast50,
      alt: "Fast 50",
      title: "Fast 50"
    },
    {
      link: "#",
      image: ImageISO,
      alt: "ISO",
      title: "ISO"
    },
    {
      link: "#",
      image: ImageClutch,
      alt: "Clutch",
      title: "Clutch"
    },
    {
      link: "#",
      image: ImageAWS,
      alt: "AWS",
      title: "AWS"
    },
    {
      link: "#",
      image: ImageGooglePartner,
      alt: "Google Partner",
      title: "Google Partner"
    },
    {
      link: "#",
      image: ImageHackthon,
      alt: "Hackthon",
      title: "Hackthon"
    },
  ]
};

export const homeProductBannerObj = {
  classes: "ht-banner",
  banner: ProductBanner,
  title: "harris teeter",
  header: "A fresh take on online grocery shopping",
  content: <><big>How did we help our client transform their business with digital retail and omnichannel experiences.</big></>
};

export const serviceTabObj = {
  title: "WHAT IS YOUR OPPORTUNITY?",
  tabItems: [
    {
      header: "Digital Experiences",
      content: "Launch new class of digital products, platforms and services",
      link: "/services/digital-product/"
    }, {
      header: "Digital Transformation",
      content: "Transform your business with technology, design and data",
      link: "/services/digital-transformation/"
    }, {
      header: "Data Analytics & AI",
      content: "Turn your data into actionable insights",
      link: "/services/data-analytics/"
    },
  ],
  serviceMediaOne: [
    {
      source: ServiceWatchBanner,
      class: "banner-img-watch"
    }, {
      source: ServicePhoneBanner,
      class: "banner-img-phone"
    }
  ],
  serviceMediaTwo: [
    {
      source: ServiceResearch,
      class: "service-banner-research"
    }, {
      source: ServiceDateRange,
      class: "service-banner-date-range"
    }, {
      source: ServiceRole,
      class: "service-banner-role"
    }, {
      source: ServiceRatio,
      class: "service-banner-ratio"
    }, {
      source: ServiceEmployee,
      class: "service-banner-employee"
    }, {
      source: ServiceMessage,
      class: "service-banner-message"
    }, {
      source: ServiceLoading,
      class: "service-banner-loading"
    }, {
      source: ServiceUser,
      class: "service-banner-user"
    },
  ],
  serviceMediaThree: [
    {
      source: ServicEarth,
      class: "service-banner-earth"
    },
  ]
};

export const homeIntroColumnObj = {
  title: "tech + business + talent",
  header: "Experts at every stage of the product development lifecycle",
  content: <> Whether you are a Fortune 500 company or a start-up, our cross-functional team offers top-notch technical, business  and creative expertise to deliver on your mission-critical initiatives. </>
};


export const homeServiceColumnObj = {
  servicesList: [
    {
      image: IconStrategy,
      alt: "product development strategy",
      title: "product development strategy",
      content: <><h5>Strategy</h5>
        <p>Ideation</p>
        <p>Design Sprints</p>
        <p>Product Mgmt</p></>
    }, {
      image: IconDesign,
      alt: "digital product design",
      title: "digital product design",
      content: <><h5>Design</h5>
        <p>User Research</p>
        <p>UX/UI Design</p>
        <p>Visual Design</p></>
    }, {
      image: IconEngineering,
      alt: "digital product engineering services",
      title: "digital product engineering",
      content: <><h5>Engineering</h5>
        <p>Web</p>
        <p>Mobile</p>
        <p>Cloud</p></>
    }, {
      image: IconInnovations,
      alt: "Innovative digital products",
      title: "Innovation and automation",
      content: <><h5>Innovations</h5>
        <p>Automation</p>
        <p>AI/ML</p>
        <p>IoT</p></>
    }
  ]
};


export const homeTestimonialObj = {
  header: "I have brought Rapidops in for massive digital transformation projects at my last three companies (all different industries) and will continue to do so. I am impressed with the exceptional quality, expertise, and speed they brought to the table.",
  image: BlockquoteImg,
  detail: <> <p>Chase Cabanillas</p> <span>CIO, Flexprint</span></>
};



